<template>
    <div class="wrapper">
        <b-table class="table" sticky-header striped hover small table-variant="secondary" :items="arcgisUnregistered" :fields="unregisteredFields" :tbody-tr-class="rowClass">
            <template v-slot:cell(Details)="row">
                <b-button size="sm" @click="row.toggleDetails" class="mr-2">
                    {{ row.detailsShowing ? $t('Hide') : $t('Details') }}
                </b-button>
            </template>
            <template v-slot:row-details="row">
                <b-card>
                    <ul class="detailsList">
                        <li v-for="(value, name) in row.item.DetailledData">
                            <div class="detailsRow"><span class="detailName">{{name}} :</span> {{ value }}</div>
                        </li>
                    </ul>
                    <!--<b-row class="mb-2">
                        <b-col sm="3" class="text-sm-right"><b>ObjectID:</b></b-col>
                        <b-col>{{ row.item.ObjectId }}</b-col>
                    </b-row>-->
                </b-card>
            </template>
        </b-table>
        <b-list-group class="legendList" horizontal>
            <b-list-group-item class="legendItem" flex-fill>
                <font-awesome-icon :icon="['fa', 'square']" size="sm" class="iconOK" /> {{ $t('InvariantNotFound') }} <!-- Invariant introuvable -->
            </b-list-group-item>
            <b-list-group-item class="legendItem" flex-fill>
                <font-awesome-icon :icon="['fa', 'square']" size="sm" class="iconKO" /> {{ $t('InvariantNonExistent') }} <!-- Invariant inexistant -->
            </b-list-group-item>
            <!--<b-button @click="testQuery">test</b-button>-->
        </b-list-group>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
    import { State, namespace } from 'vuex-class';

    import { library } from "@fortawesome/fontawesome-svg-core";
    import { faSquare } from "@fortawesome/free-solid-svg-icons";
    import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

    import * as esriLoader from 'esri-loader';

    library.add(faSquare);

    const CartoModule = namespace("CartoMod");

    @Component({
        name: 'arcgis-unregistered-dcx',
        components: {
            FontAwesomeIcon
        }
    })

    export default class ArcgisUnregisteredDcx extends Vue {

        @CartoModule.State
        private arcgisFeatures!: any[];
        @CartoModule.State
        private arcgisUnregistered!: any[];
        @CartoModule.State
        private isLoadingUnregistered!: boolean;
        @CartoModule.Mutation
        private setArcgisData!: (Invariants: object[]) => void;
        @CartoModule.Mutation
        private setArcgisUnregistered!: (Invariants: object[]) => void;
        @CartoModule.Mutation
        private setIsLoadingUnregistered!: (booleanSetter: boolean) => void;


        @Watch('arcgisFeatures')
        getUnregisteredDcx() {
            //if (this.isLoadingUnregistered == false) {
                this.setIsLoadingUnregistered(true);
                this.$Direct.postAwaitable("carto/getUnregisteredDcx", this.arcgisFeatures).then((result) => {
                    for (let unregisteredFeature of result) {
                        this.sendItemQuery(unregisteredFeature.ObjectId).then((result) => {
                            unregisteredFeature.DetailledData = result;
                        })
                    }
                    //this.setIsLoadingUnregistered(false);
                    this.setArcgisUnregistered(result);
                })
            //}
        }

        private unregisteredFields: string[] = ['Invariant', 'Details']

        rowClass(item, type) {
            if (!item || type !== 'row') return
            if (item.Invariant === 'None') return 'table-danger'
        }

        async sendItemQuery(objectId: string) {

            var itemDetails;

            await esriLoader.loadModules([
                'esri/tasks/QueryTask',
                'esri/tasks/support/Query'
            ])
                .then(async ([
                    QueryTask,
                    Query
                ]) => {
                    const queryTask = new QueryTask({
                        url: "https://sig.grandpoitiers.fr/arcgis2/rest/services/DICT/DELTA_CONSO/MapServer/1"
                    })
                    const query = new Query();
                    query.where = "OBJECTID =" + objectId
                    query.outFields = ["*"]
                    await queryTask.execute(query).then((results) => {
                        itemDetails = results.features[0].attributes
                    })
                })
            return itemDetails
        }
    }
</script>

<style scoped>
    .wrapper {
        background-color: white;
    }

    .table {
        width: 450px;
    }

    .legendItem {
        border-radius: 0 !important;
        width: 50%;
    }

    .iconKO {
        color: #F5C6CB;
        border: 1px solid black;
    }

    .iconOK {
        color: white;
        border: 1px solid black;
    }

    .detailName {
        font-weight: bold;
    }

    .detailsList {
        list-style: none;
    }
</style>